
const newModel = () => {
    return {
        congsuatDenId: null,
        ten: null,
        chieuSang: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newFEModel = () => {
    return {
        congsuatDenId: null,
        ten: null,
        chieuSang: null,
        moTa: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        congsuatDenId: item.congsuatDenId,
        ten: item.ten,
        chieuSang: item.chieuSang,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        congsuatDenId: item.congsuatDenId,
        ten: item.ten,
        chieuSang: item.chieuSang,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        congsuatDenId: null,
        ten: null,
        chieuSang: null,
        moTa: null,
        ghiChu: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        congsuatDenId: item.congsuatDenId,
        ten: item.ten,
        chieuSang: item.chieuSang,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        congsuatDenId: null,
        ten: null,
        chieuSang: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

export const congsuatDenModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


